export default function () {
    return {
        restrict: 'E',
        scope: {
            state: '@'
        },
        template: require('./status-icon.html'),
        link($scope) {
            console.log('in link', $scope.state);
        }
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/directives/statusIcon/index.js